<template>
  <div>
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="show"
      class="columns"
    >
      <div class="column is-6">
        <div class="comment">
          <div class="comment-heading columns">
            <div class="column is-12 has-text-centered">
              <strong>Tournament Details</strong>
            </div>
          </div>
          <div class="comment-heading columns is-flex">
            <div class="column is-1 is-2-touch has-text-centered">
              <i
                class="far fa-hashtag"
                aria-hidden="true"
              />
            </div>
            <div class="column is-11">
              <span>Region: #{{ tournament.venueInfo[0].region }}</span>
            </div>
          </div>
          <div class="comment-heading columns is-flex">
            <div class="column is-1 is-2-touch has-text-centered">
              <i
                class="far fa-calendar-check"
                aria-hidden="true"
              />
            </div>
            <div class="column is-11">
              <span>Date: {{ tournament.venueInfo[0].tournDate }}</span>
            </div>
          </div>
          <div class="comment-heading columns is-flex">
            <div class="column is-1 is-2-touch has-text-centered">
              <i
                class="far fa-map-marker"
                aria-hidden="true"
              />
            </div>
            <div class="column is-11">
              <span>Venue:
                <router-link
                  :to="{name: 'VenueDetails', params: {id: tournament.venueInfo[0].venueid}}"
                >{{ tournament.venueInfo[0].name }}</router-link>
              </span>
            </div>
          </div>
          <div class="comment-heading columns is-flex">
            <div class="column is-1 is-2-touch has-text-centered">
              <i
                class="far fa-globe"
                aria-hidden="true"
              />
            </div>
            <div class="column is-11">
              <span>State: {{ tournament.venueInfo[0].state }}</span>
            </div>
          </div>
          <div class="comment-heading columns is-flex">
            <div class="column is-1 is-2-touch has-text-centered">
              <i
                class="far fa-clock-o"
                aria-hidden="true"
              />
            </div>
            <div class="column is-11">
              <span>Time: {{ tournament.venueInfo[0].tournTime }}</span>
            </div>
          </div>
          <div class="comment-heading columns is-flex">
            <div class="column is-1 is-2-touch has-text-centered">
              <i
                class="far fa-users"
                aria-hidden="true"
              />
            </div>
            <div class="column is-11">
              <span>Entrants: {{ tournament.venueInfo[0].entrants }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="comment tournament-info">
          <div class="comment-heading columns">
            <div class="column is-12 has-text-centered">
              <strong>Tournament Information</strong>
            </div>
          </div>
          <div>
            <div class="comment-heading columns is-flex">
              <div
                class="column is-1 is-1-touch has-text-centered"
                style="order: 1;"
              >
                <strong class="is-size-7">#</strong>
              </div>
              <div
                class="column is-2 is-3-touch has-text-centered-touch"
                style="order: 2;"
              >
                <strong class="is-size-7">AHLNum</strong>
              </div>
              <div
                class="column is-3 is-3-touch has-text-centered-touch"
                style="order: 3;"
              >
                <strong class="is-size-7">Nandle</strong>
              </div>
              <div
                class="column is-4 is-3-touch has-text-centered-touch"
                style="order: 4;"
              >
                <strong class="is-size-7">Name</strong>
              </div>
              <div
                class="column is-2 is-2-touch has-text-centered-touch"
                style="order: 5;"
              >
                <strong class="is-size-7">Points</strong>
              </div>
            </div>
            <div
              v-for="(player, index) in paginatedPlayers()"
              class="comment-block columns is-flex-touch"
            >
              <div
                class="column is-1 is-1-touch has-text-centered"
                style="order: 1;"
              >
                <strong class="is-size-7-tablet is-size-7-touch">{{ player.place }}</strong>
              </div>
              <div
                class="column is-2 is-3-touch has-text-centered-touch"
                style="order: 2;"
              >
                <router-link
                  class="is-size-7-tablet is-size-7-touch"
                  :to="{path: `/players/${player.ahlid}`}"
                >
                  {{ player.ahlid }}
                </router-link>
              </div>
              <div
                class="column is-3 is-3-touch has-text-centered-touch"
                style="order: 3; overflow-x: hidden;"
              >
                <small class="is-size-7-tablet is-size-7-touch">{{ player.handle }}</small>
              </div>
              <div
                class="column is-4 is-3-touch has-text-centered-touch"
                style="order: 4; overflow-x: hidden;"
              >
                <small class="is-size-7-tablet is-size-7-touch">{{ player.name }}</small>
              </div>
              <div
                class="column is-2 is-2-touch has-text-centered-touch"
                style="order: 5;"
              >
                <small class="is-size-7-tablet is-size-7-touch">{{ player.points }}</small>
              </div>
            </div>
            <pagination
              :pagination="pagination"
              per-page="5"
              :total="tournament.tournResults.length"
              @paginateMinus="paginateMinus"
              @paginatePlus="paginatePlus"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Pagination from '../helpers/Pagination.vue'
  export default {
    name: 'TournamentDetails',
    components: {
      Pagination
    },
    props: ['user', 'token'],
    data () {
      return {
        show: false,
        tournament: '',
        pagination: 0
      }
    },
    created () {
      this.getTournament()
    },
    methods: {
      getTournament () {
        let id = this.$route.params.id
        let url = `general/tourn/${id}`
        this.$axios({
          method: 'POST',
          url: url,
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.show = true
            this.tournament = res.data
          })
          .catch((error) => {
            console.log(error)
          })
      },
      paginatedPlayers () {
        return this.tournament.tournResults.slice(this.pagination, (this.pagination + 5))
      },
      paginatePlus () {
        if (this.tournament.tournResults.length > (this.pagination + 5)) {
          this.pagination += 5
        }
      },
      paginateMinus () {
        if (this.pagination >= 5) {
          this.pagination -= 5
        }
      },
      components: {
        Pagination
      }
    }
  }
</script>
